// ST-32 -Claude- React hook for the admin auth state.
import { useEffect, useState } from 'react';
import { getAdminToken, getAdminUser, type AuthenticationResponse, isBusinessPortalRole } from './api';

export function useAdminAuth() {
  const [user, setUser] = useState<AuthenticationResponse | null>(getAdminUser);
  const [token, setToken] = useState<string | null>(getAdminToken);

  useEffect(() => {
    // Re-sync from storage on mount and when other tabs change auth
    const refresh = () => {
      setUser(getAdminUser());
      setToken(getAdminToken());
    };
    refresh();
    window.addEventListener('storage', refresh);
    return () => window.removeEventListener('storage', refresh);
  }, []);

  return {
    user,
    token,
    isAuthenticated: !!token && !!user && isBusinessPortalRole(user.role),
    refresh: () => {
      setUser(getAdminUser());
      setToken(getAdminToken());
    },
  };
}
